var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-26.000000, -56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-icon",
    transform: "translate(28.163109, 57.780310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1009599,23.0779872 L50.1009599,8 C50.1009599,3.581722 46.5192379,-8.11624501e-16 42.1009599,0 L8,0 C3.581722,8.11624501e-16 -5.41083001e-16,3.581722 0,8 L0,84 C-7.30735534e-15,88.418278 3.581722,92 8,92 L42.1009599,92 C46.5192379,92 50.1009599,88.418278 50.1009599,84 L50.1009599,70.6695821 L50.1009599,70.6695821",
    id: "Path-2",
    stroke: "#3E87CB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 11.6695821,
    x2: 50.1009599,
    y2: 11.6695821,
    id: "Path-3",
    stroke: "#3E87CB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70.6695821,
    x2: 50.1009599,
    y2: 70.6695821,
    id: "Path-3",
    stroke: "#3E87CB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 25.836891,
    cy: 81.21969,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 45.6695821,
    x2: 93.10096,
    y2: 45.6695821,
    id: "Path-3",
    stroke: "#F89B55",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#F89B55",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "59.2411989 27.3011573 39.5368964 46 59.2411989 64.286947"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.d5f5915737ae1bfefe2529b4ffc625ea.svg";
export { ForwardRef as ReactComponent };